import { ReactNode } from "react";

function LegendEntry({
  colorClass,
  label,
  loading,
}: {
  colorClass: string;
  label: string;
  loading?: boolean;
}): ReactNode {
  return (
    <span className={"flex items-center gap-1"}>
      <span className={`inline-block w-2.5 h-2.5 rounded-full ${colorClass}`} />
      {label}
      {loading && <span className={"text-slate-400 italic"}> …</span>}
    </span>
  );
}

export function BookedClassRoomsLegend({
  isTeacherFilterActive,
  loadingCandidates,
  loadingAvailability,
}: {
  isTeacherFilterActive: boolean;
  loadingCandidates?: boolean;
  loadingAvailability?: boolean;
}) {
  return (
    <div className={"mt-3 flex justify-end"}>
      <div className={"flex gap-3 text-xs text-slate-500"}>
        {isTeacherFilterActive ? (
          <>
            <LegendEntry colorClass={"bg-primary"} label={"Assigned"} />
            <LegendEntry
              colorClass={"bg-amber-400"}
              label={"Candidate"}
              loading={loadingCandidates}
            />
            <LegendEntry colorClass={"bg-purple-400"} label={"Mixed"} />
          </>
        ) : (
          <LegendEntry colorClass={"bg-primary"} label={"Classrooms"} />
        )}
        <LegendEntry
          colorClass={"bg-white border border-slate-300"}
          label={"Available"}
          loading={loadingAvailability}
        />
      </div>
    </div>
  );
}
